import { adDetector } from "../helpers/zones/ad_detector"
import { renderBsa } from "../helpers/zones/bsa"
import { renderPublift } from "../helpers/zones/publift"
import { renderCarbonAuto } from "../helpers/zones/carbon"
import { showFallback, clear } from "../helpers/zones/zones"

function renderAds() {
  if (document.body.getAttribute("data-zone-ab-test") == "true") {
    if (Math.random() >= 0.5) {
      console.log("BSA")
      renderBsa()
    } else {
      console.log("Publift")
      renderPublift()
    }
  } else {
    renderBsa()
    // renderPublift()
  }
}

function renderNoAds() {
  renderCarbonAuto()
  showFallback()
}

document.addEventListener("turbo:fast-load", () => {
  adDetector(renderAds, renderNoAds)
})

document.addEventListener("turbo:before-cache", clear)
